import { useContext, useMemo, useEffect } from "react";
import { NextPage } from "next";

// Components

import BannerDocs from "components/Docs/Banner";
import BannerNetworks from "components/Docs/Networks";

// Providers
import { PageProvider } from "providers/PageProvider";
import { PageContext, Footer, Header, useStaderTVL } from "mlp-sdk";

// Utils
import { prepareNavData } from "mlp-sdk/utils/common";

import { trackEvent } from "mlp-sdk/utils/firebase";

import { LP_DOCS_PAGE } from "mlp-sdk/constants/firebase";
import navData from "@constants/navData.json";
import docsPageData from "@constants/docsPage.json";
import PageHead from "@components/PageHead/PageHead";

const Docs = () => {
  const { page } = useContext(PageContext);

  const { tvl } = useStaderTVL();

  const { navData, networks } = useMemo(
    () => prepareNavData(page.data.navData, tvl),
    [page.data.navData, tvl]
  );

  useEffect(() => {
    trackEvent(LP_DOCS_PAGE);
  }, []);

  return (
    <>
      <PageHead page="docs" />

      <Header data={navData} networks={networks} tvl={tvl} />
      <BannerDocs />
      <BannerNetworks />
      <Footer data={navData} />
    </>
  );
};

const DocsPage: NextPage = ({ page }: any) => {
  return (
    <PageProvider page={page}>
      <Docs />
    </PageProvider>
  );
};

export async function getStaticProps() {
  return {
    props: {
      page: {
        data: {
          navData,
          pageData: docsPageData,
        },
        error: { navError: null, pageError: null },
      },
    },
  };
}

export default DocsPage;
